import { render, staticRenderFns } from "./ButtonVerify.vue?vue&type=template&id=4a8ce3dd&"
import script from "./ButtonVerify.vue?vue&type=script&lang=ts&"
export * from "./ButtonVerify.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonVerify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports